import React from 'react';
import { Maybe, nothing } from 'maybeasy';
import { StripeElements } from '@stripe/stripe-js';

export const StripeContext = React.createContext<Maybe<StripeElements>>(nothing());
